import React, { useEffect, useState } from 'react';
import logo from '../../images/logo.png';
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import ShareWeb from '../ShareWeb/ShareWeb'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
export default function Profile() {
    const [tienda, setTienda] = useState([]);
    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <div className='profileContain'>
            <div className='profile-header'>
                <img src={logo} alt="logo" />
                <h2 className='profile-name'>{tienda.nombre}</h2>
                {tienda.eslogan && <p className='profile-slogan'>{tienda.eslogan}</p>}
            </div>

            <div className='profile-body'>
                {tienda.direccion && (
                    <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank" className='profile-contact-item'>
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> {tienda.direccion}
                    </Anchor>
                )}
                {tienda.email && (
                    <Anchor to={`mailto:${tienda.email}`} target="_blank" className='profile-contact-item'>
                        <FontAwesomeIcon icon={faEnvelope} /> {tienda.email}
                    </Anchor>
                )}
                {tienda.telefono && (
                    <Anchor to={`tel:${tienda.telefono}`} target="_blank" className='profile-contact-item'>
                        <FontAwesomeIcon icon={faPhone} /> {tienda.telefono}
                    </Anchor>
                )}
            </div>

            <div className='profile-socials'>
                {tienda.instagram && (
                    <Anchor to={tienda.instagram} target="_blank" className='profile-social-circle' aria-label="Instagram">
                        <i className='fa fa-instagram'></i>
                    </Anchor>
                )}
                {tienda.telefono && (
                    <Anchor to={`tel:${tienda.telefono}`} target="_blank" className='profile-social-circle' aria-label="WhatsApp">
                        <i className='fa fa-whatsapp'></i>
                    </Anchor>
                )}
                {tienda.facebook && (
                    <Anchor to={tienda.facebook} target="_blank" className='profile-social-circle' aria-label="Facebook">
                        <i className='fa fa-facebook'></i>
                    </Anchor>
                )}
            </div>

            <ShareWeb />
        </div>
    )
}
